import React from 'react'
import { Accordion, AccordionDetails, AccordionProps, AccordionSummaryProps } from '@material-ui/core'
import YumSwitchAccordionSummary from '../YumSwitchAccordionSummary/YumSwitchAccordionSummary'
import Typography from '@material-ui/core/Typography'
import { UseFormReturn } from 'react-hook-form/dist/types'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

const YumCleanAccordion = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: 'white',
      border: 'none !important',
      marginBottom: '0 !important',
    },
  }),
)((props: AccordionProps) => <Accordion elevation={0} {...props} />)

interface YumSwitchAccordionProps extends AccordionSummaryProps {
  label: string
  fieldName: string
  form: UseFormReturn<any>
  alwaysOpen?: boolean
}

const YumFormSwitchAccordion = withStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: 'white',
    },
  }),
)(({ label, fieldName, form, alwaysOpen: alwaysOpenProp, children }: YumSwitchAccordionProps) => {
  const { watch, setValue } = form
  const value = watch(fieldName)
  const alwaysOpen = !!alwaysOpenProp
  const handleChange = () => setValue(fieldName, !value)
  return (
    <YumCleanAccordion expanded={value || alwaysOpen} onChange={handleChange}>
      <YumSwitchAccordionSummary expanded={value} style={alwaysOpen ? { paddingLeft: '0' } : {}}>
        {/*{expanded ? <ActiveIcon /> : <InactiveIcon />}*/}
        <Typography variant="h2" style={{ marginBottom: '0' }}>
          {label}
        </Typography>
      </YumSwitchAccordionSummary>
      <AccordionDetails style={{ padding: '12px 0 0 0' }}>
        <div style={{ flexBasis: '100%' }}>{children}</div>
      </AccordionDetails>
    </YumCleanAccordion>
  )
})

export default YumFormSwitchAccordion
